import Cookies from 'js-cookie'
import api from '@/api/api-list'
import {Sprite, Texture, Rectangle, utils, AnimatedSprite} from 'pixi.js'
let moment = require('moment')
import emojiObj from '@/config/emoji'

export const verifyRequired = required => {
	if (required instanceof Array) {
		for (let i = 0; i < required.length; i++) {
			if (!required[i].val) return required[i].message
		}
	}
}

export const deleteRedundancy = req => {
	let fields = [
		'company',
		'university',
		'university_id',
		'major',
		'major_id',
		'degree',
		'degree_id',
		'uni_school',
		'edu_type',
		'city',
		'city_id',
		'dept',
		'title',
		'name',
		'start_at',
		'end_at',
		'present',
		'description',
		'kind',
		'id',
		'is_sub_item',
		'show_tags'
	]
	let values = {}
	fields.forEach(item => {
		values[item] = req[item]
	})
	return values
}

// 与ios通信的方法
export const setupWebViewJavascriptBridge = callback => {
	//第一次调用这个方法的时候，为false
	if (window.WebViewJavascriptBridge) {
		var result = callback(WebViewJavascriptBridge)
		return result
	}
	//第一次调用的时候，也是false
	if (window.WVJBCallbacks) {
		var result = window.WVJBCallbacks.push(callback)
		return result
	}
	//把callback对象赋值给对象。
	window.WVJBCallbacks = [ callback ]
	//这段代码的意思就是执行加载WebViewJavascriptBridge_JS.js中代码的作用
	var WVJBIframe = document.createElement('iframe')
	WVJBIframe.style.display = 'none'
	WVJBIframe.src = 'https://__bridge_loaded__'
	document.documentElement.appendChild(WVJBIframe)
	setTimeout(function () {
		document.documentElement.removeChild(WVJBIframe)
	}, 0)
}

// 判断并获取jwt
export const checkJWT = isIos => {
	return new Promise(async resolve => {
		let jwt = Cookies.get('_t')
		let jwtTime = Cookies.get('_t_at') && moment(Cookies.get('_t_at') * 1000).format('YYYYMMDDHHssmm')

		let jwt_plugin = Cookies.get('_t_plugin')
		let jwtTime_plugin = Cookies.get('_t_plugin_at') && moment(Cookies.get('_t_plugin_at') * 1000).format('YYYYMMDDHHssmm')
		let jwtEndTime = moment().add(7, 'd').format('YYYYMMDDHHssmm')
		if ((!jwt || !jwtTime) && (!jwt_plugin || !jwtTime_plugin)) {
			resolve({ Authorization: '' })
		} else if (jwtTime < jwtEndTime) {
			let res = await api.auth.refreshJwt({ jwt })
			if (res.code === 1000) {
				let { jwt, jwt_timestamp } = res.data
				await updateJWT({
					jwt,
					jwt_timestamp,
					cookieEndTime: moment().add(14, 'd').valueOf()
				})
				if (isIos) {
					setupWebViewJavascriptBridge(bridge => {
						bridge.callHandler('refreshJwt', {
								cookie: `_t=${ jwt };_t_at=${ jwt_timestamp };`,
								jwt: `_t=${ jwt };`,
								jwt_at: `_t_at=${ jwt_timestamp };`
							},
							function responseCallback (responseData) {
							})
					})
				}
				resolve({
					Authorization: jwt
				})
			} else {
				updateJWT({}, 'remove')
				resolve({
					Authorization: ''
				})
			}
		} else {
			resolve({
				Authorization: jwt || jwt_plugin
			})
		}
	})
}

// 更新jwt
export const updateJWT = (data, remove, hostname) => {
	hostname = hostname || window.location.hostname
	let { jwt, jwt_timestamp, cookieEndTime } = data
	if (remove) {
		Cookies.remove('_t', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') })
		Cookies.remove('_t_at', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') })
		Cookies.remove('_t_plugin', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') })
		Cookies.remove('_t_plugin_at', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') })
	} else {
		Cookies.set('_t', jwt, {
			domain: `${ hostname.split('.')[1] }.${ hostname.split('.')[2] }`,
			path: '/',
			expires: cookieEndTime,
		})
		Cookies.set('_t_at', jwt_timestamp, {
			domain: `${ hostname.split('.')[1] }.${ hostname.split('.')[2] }`,
			path: '/',
			expires: cookieEndTime
		})

		if(hostname){
			Cookies.set('_t_plugin', jwt, {
				domain: `${ hostname.split('.')[1] }.${ hostname.split('.')[2] }`,
				path: '/',
				expires: cookieEndTime,
				sameSite:'None',
				secure: true
			})
			Cookies.set('_t_plugin_at', jwt_timestamp, {
				domain: `${ hostname.split('.')[1] }.${ hostname.split('.')[2] }`,
				path: '/',
				expires: cookieEndTime,
				sameSite:'None',
				secure: true
			})
		}
	}
}

// 跳转登录
export const toLogin = (url, loginSource) => {
	let { hostname } = window.location
	if (loginSource) {
		Cookies.set('loginSource', loginSource, {
			domain: `${ hostname.split('.')[1] }.${ hostname.split('.')[2] }`,
			path: '/',
			expires: moment()
				.add(30, 'd')
				.valueOf()
		})
	}
	Cookies.set('_r_b_t', url || window.location.href, {
		domain: `${ hostname.split('.')[1] }.${ hostname.split('.')[2] }`,
		path: '/',
		expires: moment()
			.add(30, 'd')
			.valueOf()
	})
	window.location.href = `/auth-signin?type=login&account_type=cv_account`
}

// 计算工作年限
export const workingYears = (profession_identity, workTime) => {
	if (!profession_identity) {
		return ''
	}
	if (workTime > 0) {
		return workTime > 20 ? 20 + '年以上经验' : workTime + '年经验'
	} else {
		return profession_identity || ''
	}
}

// 计算一下Safari浏览器下100vh问题
export const calcSize = () => {
	let vh = window.innerHeight * 0.01
	document.documentElement.style.setProperty('--vh', `${ vh }px`)
}

export const dealDateFormat = value => {
	return moment(value).format('YYYY-MM')
}

//将base64转换为blob
export const dataURLtoBlob = (dataurl) => {
	var arr = dataurl.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	return new Blob([u8arr], { type: mime });
}
//将blob转换为file
export const blobToFile = (theBlob, fileName) => {
	theBlob.lastModifiedDate = new Date();
	theBlob.name = fileName;
	return theBlob;
}
//单图处理
export  const formatImageWidthHeight = (width, height) => {
	if (Math.abs(width - height) <= 20) {
		if (width > height) {
			if (width <= 196) {
				return {
					w: width,
					h: height
				}
			} else {
				return {
					w: 196,
					h: 196
				}
			}
		} else {
			return {
				w: 196,
				h: 196
			}
		}
	} else {
		if (width > height) {
			if (width > 196) {
				return {
					w: 196,
					h: Math.floor(Math.max(...[(196 * height / width), 110]))
				}
			} else {
				return {
					w: width,
					h: height
				}
			}
		} else {
			if (height > 196) {
				return {
					w:  Math.floor(Math.max(...[(196 * width / height), 110])),
					h: 196
				}
			} else {
				return {
					w: width,
					h: height
				}
			}
		}
	}
}
//图片url处理
export const  UrlParamHash = (url) => {
	let params = {},
		h;
	let queryUrl = url.slice(url.indexOf("?") + 1)
	if(queryUrl === url){
		return null
	}
	let hash = queryUrl.split('&');
	for (let i = 0; i < hash.length; i++) {
		h = hash[i].split("="); //
		params[h[0]] = h[1];
	}
	return params;
}

const company_scale_options = [ //公司规模数据
  {
    value: '0,19',
    max:19,
    label: '20人以下'
  }, {
    value: '20,99',
    max:99,
    label: '20-99人'
  }, {
    value: '100,499',
    max:499,
    label: '100-499人'
  }, {
    value: '500,999',
    max:999,
    label: '500-999人'
  }, {
    value: '1000,9999',
    max:9999,
    label: '1000-9999人'
  }, {
    value: '10000,999999',
    max:1000000,
    label: '10000人以上'
  }
]
// 获取公司规模
export const getCompanyScale = (size_min, size_max) =>{
  let scale = ''
  if(!size_max){
    return ''
  }
  company_scale_options.forEach(item=>{
    if(size_max <= item.max && !scale){
      scale = item.label
    }
  })
  return scale
}

// 手机号脱敏
export const phoneDesensitization = (phone) => {
	if(!phone){
		return ''
	}
	let pat=/(\d{3})\d*(\d{2})/
	let newPhone = phone;
	try {
		newPhone = phone.replace(pat,'$1******$2');
	} catch (error) {}
	return newPhone
}

//键盘操作
export const keyboard = (keyCode) => {
	let key = {};
	key.code = keyCode;
	key.isDown = false;
	key.isUp = true;
	key.press = undefined;
	key.release = undefined;

	//The `downHandler`
	key.downHandler = function (event) {
		if (event.keyCode === key.code) {
			if (key.isUp && key.press) key.press();
			key.isDown = true;
			key.isUp = false;
		}
		// event.preventDefault();
	};

	//The `upHandler`
	key.upHandler = function (event) {
		if (event.keyCode === key.code) {
			if (key.isDown && key.release) key.release();
			key.isDown = false;
			key.isUp = true;
		}
		// event.preventDefault();
	};

	//Attach event listeners
	window.addEventListener(
		"keydown", key.downHandler.bind(key), false
	);
	window.addEventListener(
		"keyup", key.upHandler.bind(key), false
	);
	return key;
}

//碰撞检测
export const hitTestRectangle = (r1, r2) => {

	//Define the variables we'll need to calculate
	let hit, combinedHalfWidths, combinedHalfHeights, vx, vy, collision;

	//hit will determine whether there's a collision
	hit = false;

	//Find the center points of each sprite
	r1.centerX = r1.x + r1.width  / 2;
	r1.centerY = (r1.crashY ? r1.y + r1.crashY : r1.y) + (r1.height - (r1.crashY ? r1.crashY : 0)) / 2;
	r2.centerX = r2.x + (r2.parent ? r2.parent.x : 0) + r2.width / 2;
	r2.centerY = (r2.crashY ? r2.y + r2.crashY : r2.y) + (r2.parent ? r2.parent.y : 0) + (r2.height - (r2.crashY ? r2.crashY : 0)) / 2;

	//Find the half-widths and half-heights of each sprite
	r1.halfWidth = r1.width / 2;
	r1.halfHeight = (r1.height - (r1.crashY ? r1.crashY : 0)) / 2 + (r1.InitHeight ? r1.InitHeight : 0);
	r2.halfWidth = r2.width / 2 + 5;
	r2.halfHeight = (r2.height - (r2.crashY ? r2.crashY : 0)) / 2 + 5 + (r2.InitHeight ? r2.InitHeight : 0);

	//Calculate the distance vector between the sprites
	vx = r1.centerX - r2.centerX;
	vy = r1.centerY - r2.centerY;

	//Figure out the combined half-widths and half-heights
	combinedHalfWidths = r1.halfWidth + r2.halfWidth + 1;
	combinedHalfHeights = r1.halfHeight + r2.halfHeight + 1;

	//Check for a collision on the x axis
	if (Math.abs(vx) <= combinedHalfWidths ) {

		if (Math.abs(vy) <= combinedHalfHeights) {

			let overlapX = combinedHalfWidths - Math.abs(vx);
			let overlapY = combinedHalfHeights - Math.abs(vy);
			if (overlapX >= overlapY) {
				if (vy > 0) {

					collision = "up";
					//Move the rectangle out of the collision
					// r1.y = r1.y + overlapY;
				} else {
					collision = "down";
					//Move the rectangle out of the collision
					// r1.y = r1.y - overlapY;
				}

			} else {
				if (vx > 0) {
					collision = "left";
					//Move the rectangle out of the collision
					// r1.x = r1.x + overlapX;
				} else {
					collision = "right";
					//Move the rectangle out of the collision
					// r1.x = r1.x - overlapX;
				}

			}
			return  collision
		} else {

			//There's no collision on the y axis
			hit = collision;
		}
	} else {

		//There's no collision on the x axis
		hit = collision;
	}

	//`hit` will be either `true` or `false`
	return hit;
};

//多重碰撞检测
export const hitTestRectangleByList = (r1, list = []) => {
	let d = list.map(item => {
		return hitTestRectangle(r1, item)
	})
	d = [...new Set(d)].filter(item => !!item)
	return d
}

//可移动方向
export const direction = (dom, notDirectionList) => {
	let directionList = ["up", "left", "right", "bottom"]
	if(notDirectionList.length > 0){
		notDirectionList.forEach(item => {
			dom[item] = false
		})
		directionList.filter(item => !notDirectionList.includes(item)).forEach(item => {
			dom[item] = true
		})
	}else {
		dom['right'] = true;
		dom['left'] = true;
		dom['up'] = true;
		dom['down'] = true;
	}

}


//雪碧图单个还是多个
export const spriteForImageOrAnimatedSprite = (resourceName = null, options = null) => {

	if(resourceName === null){
		throw new Error("资源参数异常")
	}
	if(options === null){
		throw new Error("资源参数异常")
	}
	let TextureCache = utils.TextureCache;

	let resource = TextureCache[resourceName]

	const { width: resourceWidth , height: resourceHeight} = resource

	const {x = 0, y = 0, width = 0, height = 0, alone = true, positionX = 0, positionY = 0, loopOption, crashValue = 0 } = options

	if(alone){
		let rectangle = new Rectangle(x, y, width, height);
		resource.frame = rectangle;
		const rocket = new Sprite(resource);
		rocket.x = positionX;
		rocket.y = positionY;
		rocket.crashY = crashValue
		return rocket
	}else {
		const {row, col, total, initFrame = 0, isStart = false, initSpeed = 0.2} = loopOption
		const list = []
		for (let i = 0; i < col; i++){
			for (let j = 0; j < row; j++){
				let texture0 = new Texture(resource);
				texture0.frame = new Rectangle(j * width, i * height, width, height);
				if(list.length < total){
					list.push(texture0)
				}
			}
		}
		const user = new AnimatedSprite(list);
		user.position.set(positionX, positionY)
		user.animationSpeed = initSpeed
		user.crashY = crashValue
		user.vx = 0
		user.vy = 0
		if(isStart){
			if(initFrame){
				user.gotoAndPlay(initFrame)
			}else{
				user.play()
			}
		}else{
			user.gotoAndStop(initFrame)
		}
		return user
	}

}

export const get_tUser = (_t) => {
	_t = _t || Cookies.get('_t'); //获取cookie中的_t
	let User = {};
	if (_t) {
		try {
			let value = JSON.parse(window.atob(_t.split('.')[1]));
			if (value) {
				User = value.User;
			}
		} catch (error) {

		}
	}
	return User;
}

// 随机生成随机数
export const getRandomNum = (min, max) => {
	let list = [0,1,2,3,4];
	let randomIndex = Math.round(Math.random() * (0 - 4)) + 4
	list.forEach((item, index)=>{
		list[index] = Math.round(Math.random() * (max - min)) + min;
	})
	return list[randomIndex]
}

// 整理文字
export const messageContent = (options) => {
  let { content, messageInfo, hr_account_token } = options
  let html = content || '';
  // 更具[]拆分数据
  const showTextArray = [];
  if (/\[[^\]]+\]/.test(html)) {
    const emojiItems = html.match(/\[[^\]]+\]/g);
    emojiItems.forEach(item => {
      const wordIndex = html.indexOf(item);
      if (wordIndex > 0) {
        showTextArray.push(html.substr(0, wordIndex));
        html = html.substr(wordIndex);
      }
      showTextArray.push(item);
      html = html.substr(item.length);
    });
  }
  if (html!=undefined && html.length > 0) {
    showTextArray.push(html);
  }

  let showHtml = '';
  //判断是否是表情 及 @
  showTextArray.forEach(item=>{
    let emojiCnt = emojiObj.emojiList.emoji
    if(emojiCnt[item]){
      showHtml += `<img class="emojiImg" src="${emojiCnt[item].img}">`
    }else{
      showHtml += item
    }
  })
  return showHtml
}

export const copyToClipboard = (text) => {
  return new Promise((resolve) => {
    // 创建一个临时的textarea元素
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;

    // 将临时元素添加到DOM中，并将其设置为可见状态
    document.body.appendChild(tempTextArea);
    tempTextArea.select();

    // 执行复制操作
    document.execCommand('copy');

    // 从DOM中移除临时元素
    document.body.removeChild(tempTextArea);
    resolve();
  });
};

// 生成浏览器登录指纹
export const getEquipmentNumberFn = () => {

  const bin2hex = (s) => {
    var i,l,o = "",n;s += "";
    for (i = 0, l = s.length; i < l; i++) {
      n = s.charCodeAt(i).toString(16);
      o += n.length < 2 ? "0" + n : n;
    }
    return o;
  }

  const getUUID = (domain) => {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    var txt = domain;
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "tencent";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);

    var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
    // window.atob 用于解码使用 base-64 编码的字符串
    var bin = atob(b64);
    var crc = bin2hex(bin.slice(-16, -12));
    return crc;
  }

  return getUUID("wondercv")
}

export const verifyTrustDevice = async () => {
  try {
		if (!Cookies.get('_t')) return 'not login';

    const res = await api.cv.getCip();
    if (res.code === 1000 && res.data.internal) return '内网环境';
    
    const { code, data } = await api.cv.getCredibleEquipment({});
    if (code === 1000) {
      const { devices = [] } = data;

      const device_number = (navigator.appName + navigator.platform + navigator.product + navigator.userAgent).replace(/\//g,"") + getEquipmentNumberFn();
      const index = devices.findIndex(item => item.device_number === device_number);

      if (index === -1) {
        const hostname = window.location.hostname;
        let domain = hostname.replace(/.*?(\.wondercv.(cn|com))/gim, '$1');
        Cookies.remove('_t', { domain });
        Cookies.remove('_t_plugin', { domain });

				const wx = require('weixin-js-sdk');
				const wxMini = ua.includes('MicroMessenger') && ua.includes('miniProgram')


				if (wxMini) {
					wx.miniProgram.redirectTo({ url: '/pages/login/login'})
				} else {
					toLogin()
				}
      }
    }
  } catch (error) {
    console.log(error)
  }
}

export function startObserving(elementToWatch, threshold = 0, callback) {
	// 创建一个 Intersection Observer 实例
	const observer = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
					callback(entry.isIntersecting)
			});
	}, {
			threshold // 设置触发回调的阈值，这里是当元素50%进入或离开视野时触发
	});

	// 开始监听元素
	observer.observe(elementToWatch);

	// 在页面卸载或刷新时移除监听
	window.addEventListener("beforeunload", function() {
			observer.unobserve(elementToWatch);
			console.log("停止监听元素");
	});
}
